import { render, staticRenderFns } from "./block-charge-cost.vue?vue&type=template&id=45b1a482&scoped=true&"
import script from "./block-charge-cost.vue?vue&type=script&lang=js&"
export * from "./block-charge-cost.vue?vue&type=script&lang=js&"
import style0 from "./block-charge-cost.vue?vue&type=style&index=0&id=45b1a482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b1a482",
  null
  
)

export default component.exports